import { Controller } from "@hotwired/stimulus";
import { computePosition, autoUpdate, offset, shift } from "@floating-ui/dom";

export default class extends Controller {
  static values = { caseId: String, baseUrl: String };
  static targets = ["menu", "delete"];

  selectedFolder(folderId) {
    this.enableMenuItem(this.deleteTarget, folderId != 0);
  }

  enableMenuItem(element, enabled) {
    element.classList.toggle("disabled", !enabled);
    element.tabIndex = enabled ? 1 : -1;
    element.disabled = !enabled;
  }

  showNearEventPoint({ clientX, clientY }, timeStamp) {
    const virtualElement = {
      getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          x: clientX,
          y: clientY,
          top: clientY,
          left: clientX,
          right: clientX,
          bottom: clientY,
        };
      },
    };
    this.showMenu(virtualElement, timeStamp, {
      placement: "bottom-start",
      middleware: [
        offset({ mainAxis: -30, crossAxis: -30 }),
        shift({
          crossAxis: true,
          padding: 30,
        }),
      ],
    });
  }

  showMenu(reference, timeStamp, options) {
    this.cleanupPositionAutoUpdate();
    this.positionCleanup = autoUpdate(reference, this.menuTarget, () => {
      computePosition(reference, this.menuTarget, options).then(({ x, y }) => {
        Object.assign(this.menuTarget.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
        if (!this.element.classList.contains("show")) {
          this.element.classList.add("show");
          this.menuTarget.classList.add("show");
          this.menuTarget.show();
          this.showEventTimeStamp = timeStamp;
        }
      });
    });
  }

  hide(e) {
    if (
      !this.element.classList.contains("show") ||
      e.timeStamp <= this.showEventTimeStamp
    ) {
      return;
    }
    this.element.classList.remove("show");
    this.menuTarget.classList.remove("show");
    this.menuTarget.close();
  }

  closed() {
    this.cleanupPositionAutoUpdate();
  }

  cleanupPositionAutoUpdate() {
    if (this.positionCleanup != null) {
      this.positionCleanup();
      this.positionCleanup = null;
    }
  }
}
